import { Icon } from "@iconify/react/dist/iconify.js";
import { Box, Paper, Typography } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { ResizableBox } from "react-resizable";
import RefreshButton from "../../components/button/RefreshButton";
import { MainContainer } from "../../components/container/MainContainer";
import { PageTitleContainer } from "../../components/container/PageTitleContainer";
import { TableHeaderContainer } from "../../components/container/TableHeaderContainer";
import ContextMenu from "../../components/context-menu/ContextMenu";
import ExportAsXLSXButton from "../../components/export/ExportAsXLSXButton";
import { defaultColDef, floatFormater, rightAlignColDef } from "../../components/grid/columnDefinitions/columnDefinitions";
import { useContextProvider } from "../../components/page-context/ContextProvider";
import { Process } from "../../db_access/process";
import { Product } from "../../db_access/product";
import Footprint from "../../environment-page-components/Footprint";
import SankeyDiagram from "../../environment-page-components/SankeyDiagram";
import SystemBoundary from "../../environment-page-components/SystemBoundary";
import muiSytle from "../../style/components-style/muiStyle";
import "../../style/sidemenu-pages-style/UserLibrary.css";
import DialogSend from "./Collaborate/DialogSend";
const ProductCollaborate = () => {
  const { t } = useTranslation();
  const { refresh, setRefresh } = useContextProvider();
  const pageType = "supplier";
  const [products, setProducts] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [processData, setProcessData] = useState([]);
  const [height, setHeight] = useState(600);
  const [menuVisible, setMenuVisible] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
  const gridRef = useRef(null);
  const dialogRef = useRef();
  const handleOpenDialog = () => {
    dialogRef.current?.open();
  };

  useEffect(() => {
    Product.get_external_collaborates()
      .then((res) => res.json())
      .then((data) => setProducts(data));
  }, [refresh]);
  // useEffect(() => {
  //   const url = config.partnership.get_my_partners;
  //   const my_user_id = localStorage.getItem("username");
  //   const body = { my_user_id };
  //   fetchWithToken(url, {
  //     ...config.method.POST,
  //     headers: config.header.json,
  //     body: JSON.stringify(body),
  //   })
  //     .then((res) => {
  //       if (res.ok) {
  //         return res.json();
  //       } else {
  //         return null;
  //       }
  //     })
  //     .then((data) => {
  //       if (data) {
  //         setTemps(data.map((d) => ({ label: d.user_id, value: d.user_id })));
  //       }
  //     });
  // }, [refresh]);
  useEffect(() => {
    if (selectedProducts.length === 0) {
      setProcessData([]);
    } else {
      Process.get_by_product_ids(selectedProducts.map((i) => i.id))
        .then((res) => res.json())
        .then((data) => setProcessData(data));
    }
  }, [selectedProducts]);

  const deleteProduct = (selectedProducts) => {
    Product.delete(selectedProducts.map((s) => s.id)).finally(() => {
      setSelectedProducts([]);
      setRefresh((r) => !r);
    });
  };
  const uncollaborateProduct = (selectedProducts) => {
    Product.unarchive(selectedProducts.map((s) => s.id)).finally(() => {
      setSelectedProducts([]);
      setRefresh((r) => !r);
    });
  };
  const onSelectionChanged = (event) => {
    const selected = event.api.getSelectedRows();
    setSelectedProducts(selected);
  };
  const handleContextMenu = (e) => {
    e.preventDefault();
    setMenuPosition({ x: e.pageX, y: e.pageY });
    setMenuVisible(true);
  };
  const handleCloseMenu = () => {
    setMenuVisible(false);
  };
  const columnDefs = [
    { field: "id", hide: true },
    {
      headerName: t("Name"),
      field: "name",
      headerCheckboxSelection: true,
      checkboxSelection: false,
      cellStyle: { fontWeight: "bold", lineHeight: "1.5" },
      defaultColDef,
    },
    {
      headerName: t("Supplier"),
      field: "supplier",
      cellStyle: { lineHeight: "1.5" },
      defaultColDef,
    },
    {
      headerName: t("LEED Category"),
      field: "leed_category",
      cellStyle: { lineHeight: "1.5" },
      defaultColDef,
    },
    {
      headerName: t("Sub Category"),
      field: "sub_category",
      cellStyle: { lineHeight: "1.5" },
      defaultColDef,
    },
    {
      headerName: t("Quantity"),
      field: "quantity",
      cellStyle: { fontWeight: "bold", ...rightAlignColDef.cellStyle },
      defaultColDef,
    },
    {
      headerName: t("GWP (kg CO₂e)"),
      field: "gwp",
      cellStyle: { fontWeight: "bold", ...rightAlignColDef.cellStyle },
      defaultColDef,
      floatFormater,
    },
  ];
  const contextMenuOptions = [
    {
      label: "Uncollaborate",
      action: uncollaborateProduct,
      needSelectedItems: true,
    },
    { label: "Send", action: handleOpenDialog, needSelectedItems: true },
    { label: "Delete", action: deleteProduct, needSelectedItems: true },
  ];
  const productsGridProps = {
    columnDefs: columnDefs,
    rowData: products,
    rowSelection: "multiple",
    domLayout: "autoHeight",
    onSelectionChanged: onSelectionChanged,
    getRowId: (params) => String(params.data.id),
  };
  return (
    <MainContainer>
      <PageTitleContainer>
        <Box>
          <Typography variant="Page Title">{t("Collaborate")}</Typography>
        </Box>
      </PageTitleContainer>
      <Paper variant="Table Container">
        <TableHeaderContainer>
          <Box sx={{ paddingY: 2, paddingX: 3 }}>
            <Typography variant="Table Title">{t("User Library")}</Typography>
          </Box>
          <Box sx={{ paddingY: 1, paddingX: 2 }}>
            <ExportAsXLSXButton data={products} label="Export as .xlsx" filename="products.xlsx" />
            <RefreshButton setRefresh={setRefresh} label="Refresh table" />
          </Box>
        </TableHeaderContainer>
        <Box sx={{}}>
          <ResizableBox
            width={Infinity}
            height={height}
            minConstraints={[100, 500]}
            maxConstraints={[Infinity, 800]}
            handle={
              <Box className="custom-resize-handle">
                <Icon icon="vaadin:handle-corner" style={{ color: "grey", fontSize: "20px" }} />
              </Box>
            }
            resizeHandles={["se"]}
            onResizeStop={(_, data) => {
              setHeight(data.size.height);
            }}>
            <Box className="ag-theme-alpine grid-container" onContextMenu={handleContextMenu}>
              <AgGridReact {...productsGridProps} ref={gridRef} domLayout="normal" />
            </Box>
          </ResizableBox>
        </Box>
      </Paper>
      <Box sx={{ display: selectedProducts.length === 1 ? "block" : "none" }}>
        <SystemBoundary processData={processData} />
        <Footprint processData={processData} pageType={pageType} />
        <SankeyDiagram processData={processData} />
      </Box>
      <DialogSend ref={dialogRef} selectedItems={selectedProducts} />
      <ContextMenu x={menuPosition.x} y={menuPosition.y} visible={menuVisible} onClose={handleCloseMenu} selectedItems={selectedProducts} options={contextMenuOptions} />
    </MainContainer>
  );
};

export default ProductCollaborate;
